// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1M5_h","author":"Table_author__1qN21","authorImage":"Table_authorImage__23H8G","unreadRow":"Table_unreadRow__1Gi3r"};